import { render } from "./Form.vue?vue&type=template&id=9da0160e&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=9da0160e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9da0160e"

export default script